<template>
  <div class="wl-cerfity-standard-wrapper">
    <header class="site-manager-head-con">
       <el-form :inline="true" size="small">
      <el-form-item>
        <el-input v-model="sTitle" placeholder="请输入介绍节点标题" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="getAuthenticationList">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addCerfityData">添加</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
      </el-form-item>
    </el-form>
    </header>
    <div class="cerfity-form-content">
      <el-table
        ref="multipleeeeTablerz"
        :data="certifyData"
        tooltip-effect="dark"
        empty-text=" "
        style="width: 100%;"
        @selection-change="handleSelectionChange">
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column prop="Title" label="标题" :show-overflow-tooltip="true" width="150"></el-table-column>
        <el-table-column prop="Content" label="内容">
          <template slot-scope="scope">
            <p v-html="scope.row.Content"></p>
          </template>
        </el-table-column>
        <el-table-column prop="Cover" label="图片" width="150">
          <template slot-scope="scope">
            <div class="cerfity-img-con">
              <img :src="scope.row.Cover || defaultCerfityImg" alt>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220px">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" @click="lookClick(scope.row.Id)" size="small"  class="el-icon-view" title="编辑"></el-button>
              <el-button type="primary" @click="editCerfity(scope.row.Id,scope.row.Title,scope.row.Content,scope.row.Cover)" size="small"  class="el-icon-edit" title="编辑"></el-button>
              <el-button type="danger" @click="deleteCerfity(scope.row.Id)" size="small" class="el-icon-delete"
                  titlt="删除"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="rzpageIndex"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="rzpageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="rztotal" style="text-align: center;padding: 20px 0;">
      </el-pagination>
    </div>

    <el-dialog title="添加申请标准" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"
    :append-to-body="true">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm">
          <el-form-item label="标题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="介绍节点内容">
            <Editor v-model="ruleForm.content" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="图片" prop="AvatorUrl">
            <imageUpload :url="urlAliyunOSS" :files.sync="AvatorUrl" format="image" v-if="imgUploadShow"></imageUpload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      ruleForm: {
        title: "",
        content: ""
      },
      AvatorUrl: "",
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入序号", trigger: "blur" }]
      },
      urlAliyunOSS: "/api/design/osssign/getsign",
      certifyData: [],
      dialogVisible: false,
      logoUrl: "",
      defaultCerfityImg:require('assets/images/bg4.png'),
      cerfityId:'',
      rztotal: 0,
      rzpageSize: 5,
      rzpageIndex: 1,
      Ids:[],
      sTitle:"",
      imgUploadShow:false,
      Type:3
    };
  },
  components: {
    imageUpload
  },
  watch: {
    AvatorUrl: function(val) {
      this.logoUrl = val;
      console.log(val);
    }
  },
  created(){
    this.getAuthenticationList();
  },
  methods: {
    lookClick(id){
      this.$router.push({
        name:'authenticationNode',
        params:{
          certifiId: id
        }
      })
    },
    handleSelectionChange(val) {
      this.Ids = [];
      val.forEach(element => {
        this.Ids.push(element.Id);
      });
      console.log(this.Ids);
    },
    onPageChangeHandler(page) {
      this.rzpageIndex=page;
      this.getAuthenticationList();
    },
    handleSizeChange(val) {
      this.rzpageSize = val;
      this.getAuthenticationList(1);
    },
    getAuthenticationList(){
       let that = this;
       this.$http.post('/api/XOrg/Authentication/getBackstageAuthenticationList',{
         Title:this.sTitle,
         Type: this.Type,
         page:that.rzpageIndex,
         pageSize:that.rzpageSize
       }).then(res => {
         if(res.code > 0){
            that.certifyData = res.list;
            that.rztotal = res.pagination.totalCount;
            that.rzpageSize = res.pagination.pageSize;
            that.rzpageIndex = res.pagination.pageIndex;
         }
       });
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http.post("/api/XOrg/Authentication/addAuthentication", {
              Id:this.cerfityId,
              Cover:this.AvatorUrl,
              Content:this.ruleForm.content,
              Title:this.ruleForm.title,
              Type: this.Type
            }).then(function(rst) {
               if(rst.code > 0){
                  that.getAuthenticationList();
               }
            });
          this.dialogVisible = false;
          this.imgUploadShow = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelForm(formName) {
      this.$refs[formName].resetFields();
      this.AvatorUrl = '';
      this.dialogVisible = false;
      this.imgUploadShow = false;
    },
    addCerfityData() {
      this.AvatorUrl = '';
      this.cerfityId = '';
      this.ruleForm.title = '';
      this.ruleForm.content = '';
      this.dialogVisible = true;
      this.imgUploadShow = true;
      
    },
    editCerfity(id,title,content,cover){
      this.cerfityId = id;
      this.ruleForm.title = title;
      this.ruleForm.content = content;
      this.AvatorUrl = cover != '' ? cover : this.defaultCerfityImg;
      this.dialogVisible = true;
      this.imgUploadShow = true;
    },
    deleteCerfity(id){
      this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>{
        let that = this;
        var arr=[];
        arr.push(id);
        this.$http.post('/api/XOrg/Authentication/deleteAuthentication',{
          Ids:arr
        }).then(res => {
          if(res.code > 0){
              this.getAuthenticationList();
          }
        });
       })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    deleteAll(){
      if (this.Ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择介绍节点",
          type: "warning"
        });
        return false;
      }      
      this.$confirm('此操作将删除所选的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then (() =>{
        let that = this;
        this.$http.post('/api/XOrg/Authentication/deleteAuthentication',{
          Ids:this.Ids
        }).then(res => {
          if(res.code > 0){
            this.getAuthenticationList();
          }
        });
       })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });       
    },
  }
};
</script>
<style lang="scss">
.wl-cerfity-standard-wrapper {
  .cerfity-standard-title {
    padding: 20px 0px;
    font-size: 20px;
    font-weight: normal;
    color: #2d82ff;
  }
  .cerfity-form-content {
    margin-top: 20px;
    .cerfity-img-con {
      height: 50px;
      img {
        max-height: 50px;
      }
    }
  }
  .site-manager-head-con{
    text-align: right;
  }
}
</style>
